import { colors } from "./tokens";

export const toneTokens = {
  accent: {
    background: "#CCFBF1",
    border: "#99F6E4",
    color: "#0F766E",
  },
  neutral: {
    background: "#F1F5F9",
    border: colors.border,
    color: "#334155",
  },
  success: {
    background: "#DCFCE7",
    border: "#BBF7D0",
    color: "#166534",
  },
  warning: {
    background: "#FEF3C7",
    border: "#FCD34D",
    color: "#92400E",
  },
  danger: {
    background: "#FEE2E2",
    border: "#FECACA",
    color: "#991B1B",
  },
  info: {
    background: "#E0F2FE",
    border: "#BAE6FD",
    color: "#075985",
  },
  suspended: {
    background: "#FFE4E6",
    border: "#FECDD3",
    color: "#9F1239",
  },
};

const tokenWithTone = (label, tone, ariaLabel) => ({
  label,
  tone,
  ariaLabel,
  // Backward-compatible key retained for callers that only read `color`.
  color: toneTokens[tone]?.color || colors.textMuted,
  background: toneTokens[tone]?.background,
  border: toneTokens[tone]?.border,
});

export const severityTokens = {
  Critical: {
    ...tokenWithTone("Critical", "danger", "Severity critical"),
    background: "#FEE2E2",
    border: "#FCA5A5",
    color: "#DC2626",
  },
  High: {
    ...tokenWithTone("High", "warning", "Severity high"),
    background: "#FFEDD5",
    border: "#FDBA74",
    color: "#F97316",
  },
  Medium: {
    ...tokenWithTone("Medium", "warning", "Severity medium"),
    background: "#FEF9C3",
    border: "#FDE68A",
    color: "#CA8A04",
  },
  Low: {
    ...tokenWithTone("Low", "success", "Severity low"),
    background: "#DCFCE7",
    border: "#86EFAC",
    color: "#22C55E",
  },
  Info: tokenWithTone("Info", "info", "Severity informational"),
};

export const statusTokens = {
  Open: tokenWithTone("Open", "accent", "Status open"),
  Monitoring: tokenWithTone("Monitoring", "accent", "Status monitoring"),
  Closed: tokenWithTone("Closed", "neutral", "Status closed"),
  Overdue: tokenWithTone("Overdue", "danger", "Status overdue"),
  "In Progress": tokenWithTone("In Progress", "accent", "Status in progress"),
  Blocked: tokenWithTone("Blocked", "danger", "Status blocked"),
  Completed: tokenWithTone("Completed", "success", "Status completed"),
};

export const kpiTokens = {
  Green: tokenWithTone("Green", "success", "KPI green"),
  Yellow: tokenWithTone("Yellow", "warning", "KPI yellow"),
  Red: tokenWithTone("Red", "danger", "KPI red"),
  Stale: tokenWithTone("Stale", "neutral", "KPI stale"),
  Unknown: tokenWithTone("Unknown", "neutral", "KPI unknown"),
};

export const neutralToken = tokenWithTone("Unknown", "neutral", "Status unknown");

const statusTokenSet = {
  toneTokens,
  severityTokens,
  statusTokens,
  kpiTokens,
  neutralToken,
};

export default statusTokenSet;
